import { render, staticRenderFns } from "./NumberFormat.vue?vue&type=template&id=119fa578"
import script from "./NumberFormat.vue?vue&type=script&lang=js"
export * from "./NumberFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports